import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { Customers } from '../../store/actions/customers.actions';
import { RequestLocation } from '../../store/actions/location.actions';
import * as selectors from '../../store/reducers/index';

@Component({
  selector: 'new-customer-component',
  templateUrl: './new-customer.component.html',
  styleUrls: ['new-customer.component.scss']
})
export class NewCustomerComponent {
  public loading: Observable<boolean>;
  location$: Observable<any>;
  locationLoading$: Observable<boolean>;

  constructor(private store: Store<any>) {
    this.loading = this.store.select(selectors.getCreating('customers'));
    this.location$ = this.store.select(selectors.getLocation);
    this.locationLoading$ = this.store.select(selectors.isLocationLoading);
  }

  submitCustomer(customer: any) {
    this.store.dispatch(Customers.RequestCreateAction(customer));
  }

  locationRequest(address) {
    this.store.dispatch(new RequestLocation(address));
  }
}
